export const HS_FORM_FIELD_RR = 'HCA_HS_VITALS_RR';
export const HS_FORM_FIELD_BP = 'HCA_HS_VITALS_BP';
export const HS_FORM_FIELD_HR = 'HCA_HS_VITALS_HR';
export const HS_FORM_FIELD_TEMP = 'HCA_HS_VITALS_TEMP';
export const HS_FORM_FIELD_SPO2 = 'HCA_HS_VITALS_SPO2';
export const HS_FORM_FIELD_DIAGNOSIS = 'HCA_HS_DIAGNOSIS';
export const HS_FORM_FIELD_SI = 'HCA_HS_SECONDARY_IMPRESSION';
export const HS_FORM_FIELD_CHIEF_COMPLAINT = 'HCA_HS_CHIEF_COMPLAINT_NAME';

export const HSFormFieldsValueKeysMap = {
  [HS_FORM_FIELD_RR]: 'rr',
  [HS_FORM_FIELD_BP]: 'bp',
  [HS_FORM_FIELD_HR]: 'hr',
  [HS_FORM_FIELD_TEMP]: 'temp',
  [HS_FORM_FIELD_SPO2]: 'spo2',
  [HS_FORM_FIELD_DIAGNOSIS]: 'diagnosis',
  [HS_FORM_FIELD_SI]: 'secondaryImpression',
  [HS_FORM_FIELD_CHIEF_COMPLAINT]: 'chiefComplaint',
};
